import React, { useMemo, useState } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import classNames from 'classnames';
import { safeHTML } from '../../../utils/safeHTML';
import { useModal } from '../../../hooks/useModal';
import FaqItem from './FaqItem';
import { Scrollbar } from 'react-scrollbars-custom';
import Back from '../../features/back/Back';
import { useContent } from '../../../redux/reducer/content';
import { useTranslation } from '../../../translations';
import { copyrightParams } from '../../../constants/copyright';
import { useRequests } from '../../../redux/reducer/requests';

const TRIGGER_LINK = 'href="$%7BrulesLink%7D"';

export default function Faq({ title, copyright }) {
  const {
    authData: { isWeb },
  } = useRequests();
  const [activeFaqs, setActiveFaqs] = useState([]);
  const { closeModal, id: modalId } = useModal();
  const { faq, pdf } = useContent();
  const { t } = useTranslation();

  const close = () => closeModal({ type: 'all' });
  const formattedFaqs = useMemo(() => {
    if (!faq) return [];
    if (!pdf) return faq;
    return faq?.map((item) => {
      if (!item.answer.includes(TRIGGER_LINK)) return item;
      const splitAnswer = item.answer.split(TRIGGER_LINK);
      const pdfLink = `target="_blank" href=${pdf}`;
      return { question: item.question, answer: splitAnswer[0] + pdfLink + splitAnswer[1] };
    });
  }, [faq, pdf]);

  return (
    <CustomModal isFullPage={true}>
      <div className={classNames('faq', { faq_app: !isWeb })}>
        <div className={'faq__content'}>
          <Scrollbar>
            <div className={'faq__title'}>{safeHTML(t(title))}</div>
            <div className={'faq__items'}>
              {formattedFaqs?.map(({ question, answer }, index) => (
                <FaqItem
                  id={index}
                  key={index}
                  title={question}
                  text={answer}
                  index={index}
                  modalId={modalId}
                  activeFaqs={activeFaqs}
                  onClick={() =>
                    setActiveFaqs((prev) =>
                      activeFaqs.includes(index) ? prev.filter((faqId) => faqId !== index) : [index],
                    )
                  }
                />
              ))}
            </div>
            <span className={'faq__copyright'}>{safeHTML(t(copyright, copyrightParams))}</span>
          </Scrollbar>
        </div>
        <Back onClick={close} />
      </div>
    </CustomModal>
  );
}
